export const evaluateCondition = (conditions, shortCircuit = true) => {
  const reasons = [];
  for (let condition of conditions) {
    if (!condition.predicate) {
      reasons.push(condition.text);
      if (shortCircuit) {
        return [false, reasons];
      }
    }
  }
  return [reasons.length === 0, reasons];
};
